import NavbarWithMenu from "../components/navbar/NavbarWithMenu";
import NavbarWithImages from "../components/navbar/NavbarWithImages";
import BubbleMenu from "../components/navbar/BubbleMenu";
import CardNav from "../components/navbar/CardNav";
import ImageTitleBars from "../components/navbar/ImageTitleBars";

const NavbarShowcase = () => {
    // Sample items for BubbleMenu
    const bubbleMenuItems = [
        {
            label: 'home',
            href: '#home',
            ariaLabel: 'Home',
            rotation: -8,
            hoverStyles: { bgColor: '#3b82f6', textColor: '#ffffff' }
        },
        {
            label: 'about',
            href: '#about',
            ariaLabel: 'About',
            rotation: 5,
            hoverStyles: { bgColor: '#10b981', textColor: '#ffffff' }
        },
        {
            label: 'services',
            href: '#services',
            ariaLabel: 'Services',
            rotation: -3,
            hoverStyles: { bgColor: '#f59e0b', textColor: '#ffffff' }
        },
        {
            label: 'contact',
            href: '#contact',
            ariaLabel: 'Contact',
            rotation: -8,
            hoverStyles: { bgColor: '#8b5cf6', textColor: '#ffffff' }
        }
    ];

    // Sample items for CardNav
    const cardNavItems = [
        {
            label: 'Products',
            bgColor: '#3b82f6',
            textColor: '#ffffff',
            links: [
                { label: 'Overview', href: '#overview' },
                { label: 'Features', href: '#features' }
            ]
        },
        {
            label: 'Company',
            bgColor: '#10b981',
            textColor: '#ffffff',
            links: [
                { label: 'About', href: '#about' },
                { label: 'Team', href: '#team' }
            ]
        },
        {
            label: 'Resources',
            bgColor: '#f59e0b',
            textColor: '#ffffff',
            links: [
                { label: 'Blog', href: '#blog' },
                { label: 'Docs', href: '#docs' }
            ]
        }
    ];

    return (
        <>
            <style>{`
                .navbar-demo-container {
                    position: relative;
                    overflow: hidden;
                }
                .navbar-demo-container header {
                    position: absolute !important;
                }
                .navbar-demo-container .bubble-menu {
                    position: absolute !important;
                }
                .navbar-demo-container .card-nav-container {
                    position: absolute !important;
                }
            `}</style>

            <div className="min-h-screen bg-black py-20 px-8">
                <div className="max-w-7xl mx-auto">
                    {/* Page Header */}
                    <div className="text-center mb-20">
                        <h1 className="text-7xl font-black text-white mb-6 tracking-tight">
                            Navbar Collection
                        </h1>
                        <p className="text-xl text-gray-400 max-w-2xl mx-auto">
                            All navbar variations in one place
                        </p>
                    </div>

                    {/* Navbar Sections */}
                    <div className="space-y-16">

                        {/* 1. Navbar With Menu */}
                        <div className="space-y-6">
                            <div>
                                <h2 className="text-5xl font-bold text-amber-400 mb-3">Menu Navbar</h2>
                                <p className="text-gray-400 text-lg">
                                    Classic dropdown menu with smooth scale-y hover animations and mobile-responsive design
                                </p>
                            </div>
                            <div className="navbar-demo-container w-full h-[300px] bg-gradient-to-b from-gray-900/50 to-transparent rounded-lg">
                                <NavbarWithMenu />
                            </div>
                        </div>

                        {/* 2. Team Navbar */}
                        <div className="space-y-6">
                            <div>
                                <h2 className="text-5xl font-bold text-blue-400 mb-3">Team Navbar</h2>
                                <p className="text-gray-400 text-lg">
                                    Interactive team member showcase with hover-revealed portraits and elegant gradient accents
                                </p>
                            </div>
                            <div className="navbar-demo-container w-full h-[500px] bg-gradient-to-b from-gray-900/50 to-transparent rounded-lg">
                                <NavbarWithImages />
                            </div>
                        </div>

                        {/* 3. Bubble Menu */}
                        <div className="space-y-6">
                            <div>
                                <h2 className="text-5xl font-bold text-green-400 mb-3">Bubble Menu</h2>
                                <p className="text-gray-400 text-lg">
                                    GSAP-powered animated bubble menu with playful rotations and dynamic colors
                                </p>
                            </div>
                            <div className="navbar-demo-container w-full h-[600px] bg-gradient-to-b from-gray-900/50 to-transparent rounded-lg">
                                <BubbleMenu
                                    logo="/pixui-logo.svg"
                                    items={bubbleMenuItems}
                                    useFixedPosition={false}
                                />
                            </div>
                        </div>

                        {/* 4. Card Nav */}
                        <div className="space-y-6">
                            <div>
                                <h2 className="text-5xl font-bold text-pink-400 mb-3">Card Nav</h2>
                                <p className="text-gray-400 text-lg">
                                    Card-based navigation with smooth expand animations and elegant transitions
                                </p>
                            </div>
                            <div className="navbar-demo-container w-full h-[400px] bg-gradient-to-b from-gray-900/50 to-transparent rounded-lg">
                                <CardNav
                                    logo="/pixui-logo.svg"
                                    logoAlt="PixUI"
                                    items={cardNavItems}
                                    buttonBgColor="#3b82f6"
                                    buttonTextColor="#ffffff"
                                />
                            </div>
                        </div>

                        {/* 5. Image Title Bars */}
                        <div className="space-y-6">
                            <div>
                                <h2 className="text-5xl font-bold text-purple-400 mb-3">Image Title Bars</h2>
                                <p className="text-gray-400 text-lg">
                                    Large centered image bars with dark backgrounds and 90° rotated text on hover
                                </p>
                            </div>
                            <div className="w-full">
                                <ImageTitleBars />
                            </div>
                        </div>

                    </div>

                    {/* Bottom Note */}
                    <div className="mt-32 text-center">
                        <p className="text-gray-500 text-sm">
                            All components are fully interactive. Hover, click, and explore each navbar variation.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default NavbarShowcase;
